import script from "./RecordTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordTable.vue?vue&type=script&setup=true&lang=js"

import "./RecordTable.vue?vue&type=style&index=0&id=5d599d0b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d599d0b"]])

export default __exports__